// victor is amazing service :(
const INTERIOR_SPACES = '     ';

export const parseInteriorForVictor = (interiorCode: string) => {
	return interiorCode.replace('-', INTERIOR_SPACES);
};
